import React, { Component } from 'react';

import Image from '../../components/Image/Image';

class TecarGarantie extends Component {
    render() {
        return (
            <div id="TecarReifengarantie">
                <div className="garantie_header">
                    <div className="garantie_header_img">
                        <Image
                            src="https://techno-images.s3.eu-central-1.amazonaws.com/tecar/header-warum-tecar-garantie.png"
                            alt="Warum Tecar"
                            className="img-100"
                        />
                    </div>
                </div>
                <div className="three_instand_of_two">
                    <div className="three_instand_of_two_inner">
                        <p>
                            <span>3 STATT 2!</span>
                        </p>
                        <h1 className="font-black">Die TECAR Reifengarantie</h1>
                        <p>&nbsp;</p>
                        <p>
                            <strong className="font-bold">
                                Wir sind überzeugt von den Leistungen unserer TECAR Reifen. Darum übernehmen wir eine dreijährige
                                Reifengarantie, die über die gesetzliche Gewährleistung hinaus geht.
                            </strong>{' '}
                            Tritt dennoch ein Schadensfall auf, gelten folgende Bestimmungen – für Sie und für uns:
                        </p>
                    </div>
                </div>
                <div className="tecar-reifen-garantie">
                    <div className="tecar-reifen-garantie-container">
                        <div className="tecar-reifen-garantie-container">
                            <h2 className="uk-light">DIE TECAR REIFENGARANTIE…</h2>
                            <ul className="fa-ul tecar-reifen-garantie_list">
                                <li>
                                    <span className="fa-li">
                                        <i className="fa fa-angle-double-right" />
                                    </span>
                                    <b className="font-bold">… gilt nur für TECAR Reifen und nur für 3 Jahre</b> ab dem Kaufdatum des
                                    Neureifens
                                </li>
                                <li>
                                    <span className="fa-li">
                                        <i className="fa fa-angle-double-right" />
                                    </span>
                                    <b className="font-bold">… sichert Ihnen eine zu verrechnende Gutschrift*</b> beim ersatzweisen Kauf von
                                    Reifen der Marke TECAR über Ihren Fachhändler
                                </li>
                                <li>
                                    <span className="fa-li">
                                        <i className="fa fa-angle-double-right" />
                                    </span>
                                    <b className="font-bold">… greift nur, wenn der Kaufzeitpunkt</b> durch Kaufbeleg oder Rechnung{' '}
                                    <b className="font-bold">nachgewiesen werden kann</b>
                                </li>
                                <li>
                                    <span className="fa-li">
                                        <i className="fa fa-angle-double-right" />
                                    </span>
                                    … bezieht sich bei <b className="font-bold">Kompletträdern immer nur auf die Reifen</b>, nicht auf die
                                    Felgen
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="reifen-garantie-guard-wrapper">
                    <div className="reifen-garantie-guard">
                        <div className="reifen-garantie-guard_img">
                            <Image
                                src="https://techno-images.s3.eu-central-1.amazonaws.com/tecar/garantie-abgedeckte-schaeden.png"
                                alt="Tecar Garantie Abgedeckte Schäden"
                                className="img-100"
                            />
                        </div>

                        <div className="reifen-garantie-guard-text-wrapper">
                            <h3 className="font-black">SCHÄDEN, DIE ABGEDECKT SIND:</h3>
                            <ul className="fa-ul tecar-reifen-garantie_list">
                                <li>
                                    <span className="fa-li">
                                        <i className="fa fa-angle-double-right" />
                                    </span>
                                    Reifenschäden durch Nägel oder andere spitze Gegenstände
                                </li>
                                <li>
                                    <span className="fa-li">
                                        <i className="fa fa-angle-double-right" />
                                    </span>
                                    Beschädigung durch Bordsteinkanten
                                </li>
                                <li>
                                    <span className="fa-li">
                                        <i className="fa fa-angle-double-right" />
                                    </span>
                                    Defekte durch Vandalismus
                                </li>
                                <li>
                                    <span className="fa-li">
                                        <i className="fa fa-angle-double-right" />
                                    </span>
                                    Schäden durch Konstruktionsfehler, Fabrikations- oder Instruktionsfehler
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="reifen-garantie-guard">
                        <div className="reifen-garantie-guard_img">
                            <Image
                                src="https://techno-images.s3.eu-central-1.amazonaws.com/tecar/garantie-nicht-abgedeckte-schaeden.png"
                                alt="Tecar Garantie Abgedeckte Schäden"
                                className="img-100"
                            />
                        </div>

                        <div className="reifen-garantie-guard-text-wrapper">
                            <h3 className="font-black">
                                SCHÄDEN, DIE <span>NICHT</span> ABGEDECKT SIND:
                            </h3>
                            <ul className="fa-ul tecar-reifen-garantie_list">
                                <li>
                                    <span className="fa-li">
                                        <i className="fa fa-angle-double-right" />
                                    </span>
                                    Folgeschäden, die durch einen beschädigten Reifen entstehen, werden nicht übernommen
                                </li>
                                <li>
                                    <span className="fa-li">
                                        <i className="fa fa-angle-double-right" />
                                    </span>
                                    durch den Käufer oder einen anderen berechtigten Fahrer vorsätzlich oder grob fahrlässig herbeigeführte
                                    Schäden
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="reifen-garantie-credit">
                    <div className="reifen-garantie-credit-wrapper">
                        <div className="reifen-garantie-credit-text-box container-garantie">
                            <h2 className="font-bold">SO WIRD DER RESTWERT FÜR IHRE GUTSCHRIFT ERMITTELT:</h2>
                            <p>
                                Die Höhe des Gutschriftbetrags ist abhängig von der <span className="font-bold">Restprofiltiefe.</span> Je
                                mehr Restprofiltiefe zum Zeitpunkt des Reifenschadens vorhanden ist, desto höher fällt die Gutschrift aus
                                (siehe Tabelle).
                            </p>
                            <p>
                                <b className="font-bold">
                                    Ihre Gutschrift berechnet sich prozentual nach dem bezahlten Verkaufspreis des beschädigten Reifens.
                                </b>
                            </p>
                        </div>
                        <div className="reifen-garantie-credit-table-box container-garantie garantie-small">
                            <div className="table-container">
                                <table>
                                    <thead>
                                        <tr>
                                            <th className="text-center">Restprofiltiefe</th>
                                            <th className="text-center">Ihre Gutschrift*</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>ab 8 mm</td>
                                            <td>100 %</td>
                                        </tr>
                                        <tr>
                                            <td>7–7,9 mm</td>
                                            <td>80 %</td>
                                        </tr>
                                        <tr>
                                            <td>6–6,9 mm</td>
                                            <td>60 %</td>
                                        </tr>
                                        <tr>
                                            <td>5–5,9 mm</td>
                                            <td>40 %</td>
                                        </tr>
                                        <tr>
                                            <td>4–4,9 mm</td>
                                            <td>30 %</td>
                                        </tr>
                                        <tr>
                                            <td>3–3,9 mm</td>
                                            <td>20 %</td>
                                        </tr>
                                        <tr>
                                            <td>unter 3 mm</td>
                                            <td>Keine Gutschrift</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tecar-reifen-garantie-disclaimer">
                    <p>
                        <b className="font-bold">
                            Hinweise:
                            <br />
                        </b>
                    </p>
                    <p>
                        Garantiegeber der <strong className="font-bold">TECAR</strong> Reifen ist{' '}
                        <strong className="font-bold">TECHNO-EINKAUF GmbH in Essener Straße 110, 22149 Hamburg.</strong> Die Inanspruchnahme
                        der Garantie kann über den jeweiligen Händler erfolgen, bei denen die Reifen bezogen wurden. Die
                        Kontaktinformationen des Händlers finden Sie unten. Alternativ können Sie sich zur Geltendmachung Ihrer
                        Garantieansprüche direkt telefonisch an
                        <strong className="font-bold">TECHNO-EINKAUF GmbH</strong> wenden unter:{' '}
                        <strong className="font-bold">040.526 099-146.</strong>
                    </p>
                    <p>
                        Die Reifengarantie schränkt nicht die gesetzlichen Gewährleistungsrechte des Kunden ein. Diese Garantie unterliegt
                        ausschließlich dem deutschen Recht unter Ausschluss des UN-Kaufrechts. Gerichtsstand für alle sich aus der Garantie
                        ergebenden Ansprüche ist allein der Sitz von TECHNO-EINKAUF GmbH.
                    </p>
                    <p>*Die Gutschrift ist nicht auszahlbar.</p>
                </div>
            </div>
        );
    }
}

export default TecarGarantie;
